import Button from "components/buttons/Button"

import { ComponentProps } from "."
import { Buttons } from "./styled"

const HeaderButtons = ({
  actionButtonLabel,
  actionButtonOnClick,
  isEditMode,
  isSaveLoading,
  onPreviewClick,
  outlinedButtonLabel,
  outlinedButtonOnClick
}: Pick<
  ComponentProps,
  | "actionButtonLabel"
  | "actionButtonOnClick"
  | "isEditMode"
  | "isSaveLoading"
  | "onPreviewClick"
  | "outlinedButtonLabel"
  | "outlinedButtonOnClick"
>) => (
  <Buttons>
    {isEditMode ? (
      <Button
        disabled={isSaveLoading}
        label="Preview"
        onClick={onPreviewClick}
        outlined
        secondary
      />
    ) : null}

    <Button
      disabled={isEditMode ? isSaveLoading : undefined}
      label={outlinedButtonLabel}
      onClick={outlinedButtonOnClick}
      outlined
    />

    <Button
      disabled={isEditMode ? isSaveLoading : undefined}
      label={actionButtonLabel}
      loading={isEditMode ? isSaveLoading : undefined}
      onClick={actionButtonOnClick}
      type={isEditMode ? "submit" : "button"}
    />
  </Buttons>
)

export default HeaderButtons
